module.exports = __webpack_public_path__ + "img/human-resources.b47f20f7.webp";